<template>
  <div class="search">
    <my-header />

    <div class="pre">
      <div class="allTitle">
        <span>搜索</span>
      </div>
    </div>

    <div class="searchDetail">
      <b-container>
        <b-row>
          <b-col
            cols="6"
            xs="6"
            sm="3"
            md="3"
            xl="3"
            lg="3"
            v-for="(current, i) in dataList"
          >
            <div @click="toView('simpleDetail', current.id)">
              <img :src="current.imgPath2" />
              <div class="striping">
                <p class="p1">{{ current.title }}</p>
                <p class="p2">{{ current.name }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <my-footer />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      dataList: [],
      name: this.$route.query.name
    };
  },
  mounted() {
    this.getProductList();
  },
  methods: {
    toView(url, id) {
      this.$router.push({
        name: url,
        params: {
          id: id
        }
      });
    },
    getProductList() {
      let that = this;
      that.$axios
        .get(
          that.$global.baseURL +
            "/web/productList/getProductDataByCatalogId.form",
          {
            params: {
              name: that.name
            }
          }
        )
        .then(res => {
          if (res.data.jsonArray == "error") {
            uni.showModal({
              title: res.data.errorInfo,
              showCancel: false
            });
          } else {
            that.dataList = res.data.dataList;
          }
        });
    }
  }
};
</script>

<style>
.search .pre {
  width: 100%;
}

.search .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  letter-spacing: 10px;
  font-weight: lighter;
  font-family: "microsoft yahei";
  padding: 50px 0;
}

.search .searchDetail {
  /* width: 90%;
		margin: 0 auto; */
  width: 100%;
  margin: 0 auto;
  margin-top: 38px;
  margin-bottom: 20px;
}

.search .searchDetail img {
  width: 100%;
  margin-bottom: 20px;
  margin-left: -10px;
}

.search .searchDetail .striping {
  border-top: 1px solid #c4c4c4;
  width: 70%;
  margin-top: 10px;
  margin-bottom: 50px;
  margin-left: 18px;
}

.search .searchDetail .striping p {
  text-align: center;
  color: #595757;
}

.search .searchDetail .striping .p1 {
  font-size: 12px;
  margin-top: 18px;
  letter-spacing: 0.3px;
}

.search .searchDetail .striping .p2 {
  font-size: 20px;
  margin-top: -10px;
  margin-bottom: 30px;
}
</style>
